import React, { useCallback, useEffect, useRef, useState } from "react"
import styled, { css } from "styled-components"
import { connectSearchBox } from "react-instantsearch-dom"
import searchIcon from "../../images/search.svg"
import crossIcon from "../../images/cross.svg"
import { ButtonResetCSS } from "../atoms/Buttons"
import { useMediaQuery } from "@karbonhq/marketing-shared-utils/hooks/useMediaQuery"
import { SIDEBAR_BREAKPOINT } from "../SideBar"

const SearchInputField = styled.input`
  width: 100%;
  padding: 6px 28px 6px 8px;
  /* ask George -- colour */
  border: 1px solid #888888;
  border-radius: 4px;
  background: url("${searchIcon}") right 8px top 50% no-repeat;

  ${props =>
    props.clearable &&
    css`
      background-position: left 8px top 50%;
      padding: 6px 28px 6px 28px;
    `}

  background-size: 17px;

  ::placeholder {
    color: #ababab;
  }
`

const ClearButton = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 40px;
  border: none;
  appearance: none;
  background: transparent url("${crossIcon}") right 8px top 50% no-repeat;
  background-size: 12px;
  text-indent: -100px;
  overflow: hidden;

  :active {
    outline: none;
  }
`

export const SearchButton = styled.button`
  ${ButtonResetCSS};
  background: transparent url("${searchIcon}") 50% 50% no-repeat;
  background-size: 18px;
  text-indent: -100px;
  width: 40px;
  height: 40px;
  overflow: hidden;

  :active {
    outline: none;
  }
`

export const SearchInput = connectSearchBox(
  ({
    currentRefinement,
    refine,
    className,
    onClear,
    focusOnMount,
    ...rest
  }) => {
    const mountedRef = useRef(false)
    const inputRef = useRef()
    const isMediaSidebarBreak = useMediaQuery(SIDEBAR_BREAKPOINT)

    const clearSearch = useCallback(() => {
      refine(null)
      inputRef.current.value = ""
      setClearable(false)
      onClear && onClear()
    }, [refine, onClear])

    useEffect(() => {
      if (inputRef?.current && focusOnMount) {
        inputRef.current.focus()
      }
    }, [focusOnMount])

    useEffect(() => {
      if (mountedRef.current) {
        clearSearch()
      } else {
        mountedRef.current = true
      }
    }, [clearSearch, isMediaSidebarBreak])

    const [clearable, setClearable] = useState(false)

    const onChange = e => {
      setClearable(!!e.target.value)
      e.persist()
      refine(e.target.value)
    }

    return (
      <div
        className={className}
        css={css`
          position: relative;
        `}
      >
        <SearchInputField
          clearable={clearable}
          type="text"
          ref={inputRef}
          placeholder="Search for a template..."
          aria-label="Search"
          onChange={onChange}
          value={currentRefinement}
          {...rest}
        />
        {clearable && <ClearButton onClick={clearSearch}>clear</ClearButton>}
      </div>
    )
  }
)
